import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import {
  ButtonStyled,
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  ExtraText,
  GridContainerStyled,
  TaglineContainer,
  TaglineSubtitle,
  TaglineTitle,
} from "./styles";

export default function FreePackage(props) {
  const { onScrollToPackage } = props;
  const [solutions, setSolutions] = useState([]);
  const [solutionsDescription, setSolutionsDescription] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = content_my;

    const { advantageTitle, advantageSection, advantageSubtitle } =
      response || {};
    setSolutions(advantageTitle);
    setSolutionsDescription(advantageSubtitle);
    setSolutionsCard(advantageSection);
  }

  const buttonCTA = "Claim my free post";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function scrollToFaq() {
    onScrollToPackage();
  }

  function triggerInfoDialog() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "post_for_free_package",
    });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <TaglineContainer>
        <TaglineTitle
          dangerouslySetInnerHTML={{ __html: solutions }}
        ></TaglineTitle>

        <TaglineSubtitle
          dangerouslySetInnerHTML={{ __html: solutionsDescription }}
        ></TaglineSubtitle>
      </TaglineContainer>

      <CardContainer>
        <CardListContainer>
          <CardImage
            src={
              "https://assets.wobbjobs.com/images/employer_landing/internship_token_3d.png"
            }
            alt={"Card Image"}
          />

          <CardTextContainer>
            <CardText type={"title"}>3 Free Internship Tokens</CardText>
            <CardText type={"desc"}>(per month)</CardText>
          </CardTextContainer>
        </CardListContainer>

        <CardListContainer>
          <CardImage
            src={
              "https://assets.wobbjobs.com/images/employer_landing/specialty_job_credit_3d.png"
            }
            alt={"Card Image"}
          />

          <CardTextContainer>
            <CardTextContainer style={{ gap: "4px" }}>
              <CardText type={"title"}>3 Free Specialty Job Credits</CardText>
              <CardText type={"desc"}>(per month)</CardText>
            </CardTextContainer>
            <CardText type={"small_desc"}>
              For in-store & on-ground roles in Retail,
              <br /> F&B, Hospitality only —{" "}
              <a
                onClick={scrollToFaq}
                style={{ color: "#512ACC", textDecoration: "underline" }}
              >
                see FAQ
              </a>
            </CardText>
          </CardTextContainer>
        </CardListContainer>

        <CardListContainer>
          <CardImage
            src={
              "https://assets.wobbjobs.com/images/employer_landing/youth_talent.png"
            }
            alt={"Card Image"}
          />

          <CardTextContainer>
            <CardText type={"title"}>
              Access to Malaysia’s
              <br /> youth talent pool
            </CardText>
          </CardTextContainer>
        </CardListContainer>
      </CardContainer>

      <TaglineContainer style={{ gap: "8px" }}>
        <TaglineSubtitle $bold>
          No hidden fees. No commitments. Just more opportunities to hire youth
          talent.
        </TaglineSubtitle>
        <ExtraText>(See FAQ for details on which roles qualify.)</ExtraText>
      </TaglineContainer>
      <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
    </GridContainerStyled>
  );
}
